const slideShows = [...document.querySelectorAll('.js-slide-show')];

slideShows.forEach((slideShow) => {
    const slideShowCaptions = slideShow.parentNode.querySelector('.js-slide-show-captions');

    // eslint-disable-next-line
    const flkty = new window.Flickity(slideShow, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
    });

    if (slideShowCaptions) {
        // eslint-disable-next-line
        const flktyCaptions = new window.Flickity(slideShowCaptions, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            asNavFor: slideShow,
            prevNextButtons: false,
            draggable: false,
            selectedAttraction: 1,
            friction: 1,
        });
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slideshow.js